import type { Order } from '../types/Order';

export function parseOrders(orders: Order[]) {
  orders.forEach((item) => {
    item.color = item.color ? item.color.trim() : ''; // Fix possible space like 'A1' vs ' A1'
    item.delivery_time = new Date(item.delivery_time);
    item.created_at = new Date(item.created_at);
    if (Object.keys(item.address ?? {}).length === 0) {
      item.address = null;
    }
    item.files.forEach((file) => {
      file.created_at = new Date(file.created_at);
    });
  });
}
